import React, {Component} from "react";
import FormOverlay from "../../../../components/Modal";
import FieldGroup from "../../../../components/FieldGroup";
import SelectWrap from "../../../../components/SelectWrap";
import countries from "../../../../data/countries";

class CreateConversionForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            affid: "",
            subid: "",
            country: null,
            cutoff: ""
        }

        this.handleFieldChange = this.handleFieldChange.bind(this);
    }

    handleFieldChange({ target }) {
        this.setState({ [target.name]: target.value });
    }

    async handleSubmit(event) {
        event.preventDefault();

        this.props.onCreate(this.state);
    }

    render() {
        return (
            <div>
                <FormOverlay onHide={this.props.onHide}>
                    <div style={{margin: '2em 0em 0.5em 3.5em'}}>
                        <h3>
                            Create conversion
                        </h3>
                    </div>
                    <div className="d-flex justify-content-center">
                        <form style={{ margin: '0.5em' }}>
                            <FieldGroup
                                name="affid"
                                onChange={this.handleFieldChange}
                                value={this.state.affid}
                                required
                                label="Affiliate ID"
                            />

                            <FieldGroup
                                name="subid"
                                onChange={this.handleFieldChange}
                                value={this.state.subid}
                                required
                                label="Sub ID"
                            />

                            <SelectWrap
                                values={countries}
                                value={this.state.country}
                                label="Country: "
                                name="country"
                                onChange={(e)=> this.setState({ country: e.target.value })}
                            />

                            <FieldGroup
                                name="cutoff"
                                onChange={this.handleFieldChange}
                                value={this.state.cutoff}
                                type={'number'}
                                required
                                label="Cutoff"
                            />

                            <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={this.handleSubmit.bind(this)}
                                style={{marginBottom: '1em'}}
                            >
                                Create
                            </button>
                        </form>
                    </div>
                </FormOverlay>
            </div>
        )
    }
}

export default CreateConversionForm;



// WEBPACK FOOTER //
// ./src/scenes/PeerclickConversionsCutoff/components/CreateConversionForm/index.js